import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { useNavigate} from "react-router-dom";
import logo from '../ecoindexhd.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('features');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['features', 'how-it-works', 'benefits', 'company-benefits', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveLink(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

   const navigate = useNavigate();
    
    const handleLogin = () => {
      navigate("/login");
      window.history.go(-1);
    };
    

  return (
    <nav className="app-main-navbar">
      <div className="app-logo"><img src={logo} alt="logo" /></div>
      <div className={`app-links ${isMenuOpen ? 'active' : ''}`}>
        <a href="#features" className={activeLink === 'features' ? 'active' : ''}>Home</a>
        <a href="#how-it-works" className={activeLink === 'how-it-works' ? 'active' : ''}>Why It Matters</a>
        <a href="#benefits" className={activeLink === 'benefits' ? 'active' : ''}>Our Solution</a>
        <a href="#company-benefits" className={activeLink === 'company-benefits' ? 'active' : ''}>Benefits</a>
        <a href="#contact" className={`app-contact-button ${activeLink === 'contact' ? 'active' : ''}`} onClick={handleLogin}>Get Started</a>
      </div>
      <div className="hamburger" onClick={toggleMenu}>
        <div className={`bar ${isMenuOpen ? 'active' : ''}`}></div>
        <div className={`bar ${isMenuOpen ? 'active' : ''}`}></div>
        <div className={`bar ${isMenuOpen ? 'active' : ''}`}></div>
      </div>
    </nav>
  );
};

export default Navbar;